// MOCK DATA ONLY (frontend teaser). Replace with backend API later.

export const COMPANY = {
  name: "National Wire Products",
  tagline:
    "Trusted Manufacturer & Supplier of Steel Wires, Fencing & Geotechnical Solutions in Northeast India",
  locationShort: "Guwahati, Assam",
  addressLine: "IIT Road, Amingaon, Guwahati - 781001",
  addressLine2: "NS Road, Fatasil, Guwahati - 781009",
  phone: "+917011332421",
  phones: ["+917011332421", "+919508430876", "+916000189894"],
  phoneContacts: [
    { label: "Office", phone: "+916000189894" },
    { label: "Amit Naruka", phone: "+919508430876" },
    { label: "Sumit Naruka", phone: "+917011332421" }
  ],
  whatsapp: "+917099867499",
  email: "nwireproducts@gmail.com",
  years: 25,
  certification: "ISO 9001:2015 Certified",
  serviceArea: [
    "Assam",
    "Arunachal Pradesh",
    "Meghalaya",
    "Nagaland",
    "Tripura",
    "Mizoram",
    "Manipur",
    "Nearby states (on bulk order)"
  ]
};

const U = (url) => `${url}?auto=format&fit=crop&w=1800&q=75`;

export const IMAGES = {
  hero: U("/images/hero.jpg"),
  welding: U("/images/chainlink-mc.jpg"),
  facility: U("/images/facility.jpg"),

  // Quality/inspection image chosen to load reliably (avoid some hosts blocking automation)
  quality: U("/images/vernier.jpg"),

  // Category hero images
  steelWires: U("/images/steel_wires.jpg"),
  chainlink: U("/images/fence.webp"),
  gabion: U("/images/geotechnical-structures.webp"),

  // Product thumbnails (mostly representative)
  giWire: U("/images/gi-wire.jpg"),
  msWire: U("/images/MS-wire.jpg"),
  htWire: U("/images/ht-wire.jpg"),
  pvcCoatedGiWire: U("/images/pvc1.webp"),
  spiralWire: U("/images/annealed.jpg"),
  bindingWire: U("/images/msbinding.jpg"),

  chainlinkFence: U("/images/Chainlink-roll.jpg"),
  knottedFencing: U("/images/knotted_fence.jpg"),
  weldedMesh: U("/images/welded-mesh.jpg"),
  hescoBasket: U("/images/hesco_basket.jpg"),
  pvcCoatedChainlinkFence: U("/images/PVC_Chainlink.jpg"),
  giBarbedWire: U("/images/barbedbw.jpeg"),
  goatproofFence: U("/images/Grassland.jpg"),
  concertinaWire: U("/images/concertina1.jpeg"),
  razorWire: U("/images/razor_blade_wire.jpg"),

  giGabionBox: U("/images/gi-gabion-box.jpg"),
  pvcCoatedGabionBox: U("/images/pvc-gabion-box.jpeg"),
  dtMesh: U("/images/dt-mesh.jpg"),
  giWireNettingSheet: U("/images/GI-wire-netting-sheet.jpg"),

  // Geosynthetics (representative images)
  geotextile: U("/images/geotextile.jpg"),
  geobag: U("/images/geobag.jpg"),
  geoComposite: U("/images/geocomposite.jfif"),
  geoGrid: U("/images/geogrid.jpg"),

  // Detail page secondary
  chainlinkDetail: U("/images/collage3.jpg")
};

export const SEO = {
  northeastStates: [
    "Assam",
    "Arunachal Pradesh",
    "Meghalaya",
    "Manipur",
    "Mizoram",
    "Nagaland",
    "Tripura"
  ],
  majorCities: [
    "Guwahati",
    "Itanagar",
    "Shillong",
    "Imphal",
    "Dimapur",
    "Kohima",
    "Aizawl",
    "Agartala",
    "Dibrugarh",
    "Jorhat",
    "Tinsukia",

    // Additional Northeast cities & districts
    "Dharmanagar",
    "Churchandpur",
    "Moirang",
    "Senapati",
    "Ukhrul",
    "Silchar",
    "Tezpur",
    "Dhubri",
    "Sivasagar",
    "Golaghat",
    "Tawang",
    "Along",
    "Pasighat",
    "Namsai",
    "Tura",
    "Jowai",
    "Champhai"
  ],
  keywords: [
    // Core
    "Steel wire manufacturer in Guwahati",
    "GI Wire Manufacturer in Guwahati",
    "MS Wire Supplier Assam",
    "Binding Wire Supplier Guwahati",
    "Spiral Wire Supplier Assam",

    // Fencing
    "Chainlink Fence Supplier Assam",
    "PVC Coated Chainlink Fence Supplier Guwahati",
    "Barbed Wire Supplier Assam",
    "Razor Wire Supplier Guwahati",
    "Concertina Wire Supplier Northeast India",
    "Knotted Fencing Supplier Assam",

    // Geotech
    "Gabion Box Manufacturer Northeast India",
    "DT Mesh Supplier Northeast India",
    "Geotextile Supplier Assam",
    "Geo Grid Supplier Northeast India",

    // Regional intent (states)
    "Fencing products supplier Assam",
    "Fencing products supplier Arunachal Pradesh",
    "Fencing products supplier Meghalaya",
    "Fencing products supplier Manipur",
    "Fencing products supplier Mizoram",
    "Fencing products supplier Nagaland",
    "Fencing products supplier Tripura",

    // Regional intent (cities)
    "GI wire supplier Guwahati",
    "Chainlink fence supplier Shillong",
    "Gabion box supplier Itanagar",
    "Razor wire supplier Imphal",
    "Fencing supplier Dimapur",
    "Fencing supplier Kohima",
    "Fencing supplier Aizawl",
    "Fencing supplier Agartala",
    "GI wire supplier Dibrugarh",
    "GI wire supplier Jorhat",
    "GI wire supplier Tinsukia"
  ]
};

// Typical industry ranges (confirm during RFQ)
export const SPEC_TEMPLATES = {
  wire: {
    material: "Mild Steel / Galvanized Steel (as specified)",
    diameter: "1.60 mm – 6.00 mm (typical)",
    coating: "Hot-dip galvanised / Electro galvanised",
    tensile: "350 – 700 MPa (typical, grade-dependent)",
    bundle: "25 – 200 kg coil (typical)",
    standards: "IS / ASTM (as applicable)"
  },
  fencing: {
    material: "GI / PVC Coated GI / High Carbon Steel (as specified)",
    size: "As per mesh & aperture requirements",
    coating: "GI / PVC coating",
    tensile: "Grade-dependent",
    bundle: "Rolls / bundles as specified",
    standards: "IS / ASTM (as applicable)"
  },
  geotech: {
    material: "GI / PVC Coated GI / Polymer (as specified)",
    size: "As per project drawings / BOQ",
    coating: "GI / PVC / Polymer",
    tensile: "As per product type",
    bundle: "Bundles / rolls / pallets (as specified)",
    standards: "IS / ASTM (as applicable)"
  }
};

// Per-product specs: each product can override these independently (edit in this file).
const makeSpec = (base, overrides) => ({ ...base, ...(overrides || {}) });
const wireSpec = (overrides) => makeSpec(SPEC_TEMPLATES.wire, overrides);
const fencingSpec = (overrides) => makeSpec(SPEC_TEMPLATES.fencing, overrides);
const geotechSpec = (overrides) => makeSpec(SPEC_TEMPLATES.geotech, overrides);

export const PRODUCT_CATEGORIES = [
  {
    id: "steel-wires",
    name: "Steel Wires",
    short:
      "Consistent diameter, clean finish and dependable tensile strength for fabrication & construction supply.",
    image: IMAGES.steelWires,
    products: [
      {
        slug: "gi-wire",
        name: "GI Wire",
        image: IMAGES.giWire,
        imageNote: "GI Wire",
        desc:
          "Galvanized iron wire manufactured for durability and corrosion resistance—ideal for tying, binding, fencing, and industrial usage.",
        template: "wire",
        spec: wireSpec({
          material: "Galvanized Steel",
          diameter: "2.00 mm – 5.00 mm (typical)",
          coating: "Hot-dip galvanised / Electro galvanised (as specified)",
          bundle: "25 – 100 kg coil (typical)",
        }),
        features: [
          "Uniform zinc coating",
          "Clean finish, smooth winding",
          "Available in multiple gauges",
          "Bulk supply for contractors & distributors"
        ],
        applications: [
          "Binding & tying in construction",
          "Fencing and agricultural use",
          "Industrial packing and bundling"
        ]
      },
      {
        slug: "pre-stressed-concrete-wire-ht-wire",
        name: "Pre-Stressed Concrete Wire (HT Wire)",
        image: IMAGES.htWire,
        imageNote: "PC Wire 4.00 mm",
        desc:
          "High tensile Pre-Stressed Indented Concrete Wire as per IS 6003:2010 for PSC applications, engineered for strength-critical structural components.",
        template: "wire",
        spec: wireSpec({
          material: "High Tensile Steel",
          diameter: "4.00 mm (typical)",
          coating: "Indented",
          tensile: "1500 – 1800 MPa (typical, grade-dependent)",
          bundle: "500 kg coil (typical)",
          standards: "As per IS 6003:2010",
        }),
        features: [
          "High tensile grades available",
          "Low relaxation options (on request)",
          "Bulk supply for infrastructure work"
        ],
        applications: [
          "PSC poles and sleepers",
          "Pre-stressed beams",
          "Infrastructure manufacturing"
        ]
      },
      {
        slug: "ms-wire",
        name: "MS Wire",
        image: IMAGES.msWire,
        imageNote: "MS Wire",
        desc:
          "Mild steel wire suited for fabrication, general engineering and binding applications, with reliable drawability.",
        template: "wire",
        spec: wireSpec({
          material: "Mild Steel",
          diameter: "2.00 mm – 6.00 mm (typical)",
          coating: "Black / Bright",
          tensile: "350 – 600 MPa",
          bundle: "250 – 500 kg coil (typical)",
          standards: "As per IS 280",
        }),
        features: [
          "Good ductility for fabrication",
          "Consistent surface quality",
          "Custom diameters on request"
        ],
        applications: [
          "Fabrication & welding shops",
          "Binding in construction",
          "General engineering"
        ]
      },
      {
        slug: "binding-wire",
        name: "Binding Wire",
        image: IMAGES.bindingWire,
        imageNote: "MS Binding Wire",
        desc:
          "Soft, easy-to-twist wire used for fast tying and binding at construction sites—ideal for reinforcement work, bundling and packing.",
        template: "wire",
        spec: wireSpec({
          material: "Soft MS / Annealed",
          diameter: "0.90 mm – 1.60 mm (typical)",
          coating: "Black / Annealed",
          tensile: "Low / medium tensile (tying grade)",
          bundle: "25 – 50 kg coil (typical)",
          standards: "As per IS 280",
        }),
        features: [
          "Good ductility for manual tying",
          "Uniform finish and consistent winding",
          "Available in multiple gauges",
          "Bulk supply for project sites"
        ],
        applications: [
          "Rebar tying and reinforcement binding",
          "Construction site bundling",
          "Industrial packing and strapping support"
        ]
      },
      {
        slug: "pvc-coated-gi-wire",
        name: "PVC Coated GI Wire",
        image: IMAGES.pvcCoatedGiWire,
        imageNote: "PVC Coated GI Wire",
        desc:
          "GI wire with protective PVC layer for enhanced corrosion resistance and a cleaner finish in outdoor environments.",
        template: "wire",
        spec: wireSpec({
          material: "Plastic coated Galvanized Steel",
          diameter: "3.00 mm – 5.00 mm (typical)",
          coating: "PVC coated over GI",
          tensile: "350 – 650 MPa (typical)",
          bundle: "50 kg coil (typical)",
        }),
        features: [
          "Improved corrosion resistance",
          "Multiple colors (on request)",
          "Smooth handling, reduced abrasions"
        ],
        applications: [
          "Garden and perimeter fencing",
          "Coastal / high moisture areas",
          "Industrial site fencing"
        ]
      },
      {
        slug: "spiral-wire",
        name: "Spiral Wire",
        image: IMAGES.spiralWire,
        imageNote: "Spiral Wire",
        desc:
          "Spiral wire supplied to pole, hume pipe industries to keep concrete wire and TMT rods in place",
        template: "wire",
        spec: wireSpec({
          material: "Annealed MS",
          diameter: "2.00 mm – 4.00 mm (typical)",
          coating: "Black / Annealed",
          tensile: "Low / medium tensile (tying grade)",
          bundle: "250 – 500 kg coil (typical)",
        }),
        features: [
          "Convenient coil form for handling",
          "Custom diameters and coil sizes on request",
          "Suitable cement pole and pipe industries",
          "Consistent manufacturing for bulk orders"
        ],
        applications: [
          "Cement pole and pipe industries",
          "Construction applications",
          "Project-specific fabrication requirements"
        ]
      }
    ]
  },
  {
    id: "fencing-products",
    name: "Fencing Products",
    short:
      "Field-proven fencing solutions for infrastructure, industrial sites, borders, farms and residential projects.",
    image: IMAGES.chainlink,
    products: [
      {
        slug: "chainlink-fence",
        name: "Chainlink Fence",
        image: IMAGES.chainlinkFence,
        imageNote: "Chain-link Fence Roll",
        desc:
          "Durable chainlink fencing for perimeter security and site demarcation, supplied in rolls for fast installation.",
        template: "fencing",
        features: [
          "Uniform mesh opening",
          "GI finish for corrosion resistance",
          "Multiple heights and apertures"
        ],
        spec: fencingSpec({
          material: "Galvanized Iron",
          size: "Aperture/mesh (30 mm - 100 mm), Wire (2.00 mm - 4.00 mm)",
          coating: "Hot dipped Galvanized",
          tensile: "Size dependent",
          bundle: "Rolls (Normal / Compact)",
          standards: "As per IS 2721:2003",
        }),

        applications: ["Factories", "Construction sites", "Institutions", "Perimeter security"]
      },
      {
        slug: "gi-barbed-wire",
        name: "GI Barbed Wire",
        image: IMAGES.giBarbedWire,
        imageNote: "GI Barbed Wire",
        desc:
          "Galvanized barbed wire as per IS 278:2009 for cost-effective deterrence and boundary protection.",
        template: "fencing",
        features: ["Sharp barbs", "Uniform spacing", "GI coating for durability"],
        spec: fencingSpec({
          material: "Galvanized Steel",
          size: "4-point barbs",
          coating: "Hot dipped Galvanized",
          tensile: "Size dependent",
          bundle: "Coils",
          standards: "As per IS 278:2009",
        }),

        applications: ["Agriculture", "Perimeter security", "Construction boundaries"]
      },
      {
        slug: "grassland-goatproof-fence",
        name: "Grassland Goatproof Fence",
        image: IMAGES.goatproofFence,
        imageNote: "Grassland Fence",
        desc:
          "Fence designed to deter livestock intrusion—ideal for farms and plantation boundaries.",
        template: "fencing",
        spec: fencingSpec({
          material: "Galvanized Steel",
          size: "Field fence mesh spacing 100 mm / 125 mm",
          coating: "Hot dipped Galvanized",
          tensile: "Size dependent",
          bundle: "Rolls (typical)",
        }),
        features: ["Tighter lower mesh", "Strong edge wires", "Fast installation"],
        applications: ["Farms", "Plantations", "Animal fencing"]
      },

      {
        slug: "concertina-wire",
        name: "Concertina Wire",
        image: IMAGES.concertinaWire,
        imageNote: "Concertina Wire",
        desc:
          "High-security concertina wire coils for critical perimeter protection.",
        template: "fencing",
        spec: fencingSpec({
          material: "Galvanized Steel",
          size: "Coil diameter (450 mm / 600 mm / 1050 mm)",
          coating: "Hot dipped Galvanized",
          bundle: "Coils",
        }),
        features: ["High deterrence", "GI finish options", "Rapid deployment"],
        applications: ["Borders", "Industrial security", "Restricted zones"]
      },
      {
        slug: "pvc-coated-chainlink-fence",
        name: "PVC Coated Chainlink Fence",
        image: IMAGES.pvcCoatedChainlinkFence,
        imageNote: "Green PVC coated Chainlink Fence",
        desc:
          "PVC coated chainlink for enhanced corrosion resistance and a premium finish in outdoor conditions.",
        template: "fencing",
        spec: fencingSpec({
          material: "Plastic coated Galvanized Steel",
          size: "Aperture/mesh (30 mm - 100 mm), Wire (2.00 mm - 4.00 mm)",
          coating: "PVC coated over GI",          
          bundle: "Rolls (typical)",
        }),
        features: [
          "PVC coating for longer life",
          "Better aesthetics",
          "Ideal for coastal/high rainfall zones"
        ],
        applications: ["Sports grounds", "Residential perimeters", "Industrial campuses"]
      },
      {
        slug: "knotted-fencing",
        name: "Knotted Fencing",
        image: IMAGES.knottedFencing,
        imageNote: "Knotted Fence",
        desc:
          "High-strength knotted fencing designed for farm and boundary applications—suited for large perimeters with durable knot joints.",
        template: "fencing",
        spec: fencingSpec({
          material: "Galvanized Steel",
          coating: "Hot dipped Galvanized",
          tensile: "Size dependent",
          size: "Knot spacing & height as specified",
          bundle: "Rolls (typical)",
        }),
        features: [
          "Strong knot joints for better tension holding",
          "Suitable for long runs and large perimeters",
          "Custom heights and spacing (on request)",
          "Fast installation for field fencing"
        ],
        applications: [
          "Agriculture and farm boundaries",
          "Animal fencing for open areas",
          "Perimeter demarcation for plantations"
        ]
      },
      {
        slug: "razor-blade-wire-rbt",
        name: "Razor Blade Wire (RBT)",
        image: IMAGES.razorWire,
        imageNote: "RBT Wire",
        desc:
          "Razor wire tape for high-security fencing requirements in sensitive installations.",
        template: "fencing",
        spec: fencingSpec({
          material: "Galvanized Steel",
          coating: "Hot dipped Galvanized",
          size: "Wire dia, blade type and spacing as specified",
          tensile: "Size dependent",
          bundle: "Coils (typical)",
        }),
        features: ["Sharp blades", "Tough core wire", "Multiple coil diameters"],
        applications: ["Defense", "Airports", "Industrial perimeters"]
      },
      {
        slug: "welded-mesh",
        name: "Welded Mesh",
        image: IMAGES.weldedMesh,
        imageNote: "GI Welded Mesh",
        desc:
          "Welded mesh supplied for fencing, partitions and reinforcement applications—consistent grid, quick installation and site-friendly handling.",
        template: "fencing",
        spec: fencingSpec({
          material: "Galvanized Steel / Mild Steel (as specified) ",
          size: "Grid size as specified",
          coating: "GI / MS (as specified)",
          bundle: "Sheets / rolls (as specified)",
        }),
        features: [
          "Rigid welded joints for strength",
          "Uniform grid spacing",
          "Available in sheets/rolls (as applicable)",
          "Custom sizes and wire diameter options",
          "Available in MS as well as GI options"
        ],
        applications: [
          "Site partitions and enclosures",
          "Industrial fencing",
          "Construction reinforcement (as specified)"
        ]
      }
    ]
  },
  {
    id: "geotechnical-structures",
    name: "Geotechnical Structures",
    short:
      "Engineered solutions for slope stabilization, riverbank protection, erosion control and soil reinforcement.",
    image: IMAGES.gabion,
    products: [
      {
        slug: "gi-gabion-box",
        name: "Gabion Box",
        image: IMAGES.giGabionBox,
        imageNote: "GI Gabion Box",
        desc:
          "Hot-dip galvanized gabion boxes for durable riverbank protection and retaining structures.",
        template: "geotech",
        spec: geotechSpec({
          material: "GI double-twisted mesh",
          size: "As per box size & mesh opening",
          coating: "Hot dipped Galvanized",
          bundle: "Bundles of stacked Boxes",
          standards: "As per IS 16014:2018",
        }),
        features: ["Uniform mesh", "High corrosion resistance", "Site-ready fabrication"],
        applications: ["Riverbank protection", "Retaining walls", "Erosion control"]
      },
      {
        slug: "geotextile",
        name: "Geotextile",
        image: IMAGES.geotextile,
        imageNote: "Geotextile",
        desc:
          "Non-woven Geotextile fabric for filtration, separation and drainage improvement in civil works.",
        template: "geotech",
        spec: geotechSpec({
          material: "Non-woven / woven (as specified)",
          size: "GSM and roll size as specified",
          coating: "N/A",
          tensile: "As per GSM/type",
          bundle: "Rolls (as specified)",
        }),
        features: ["Filtration", "Separation", "Durable"],
        applications: ["Road subgrade", "Drainage", "Embankments"]
      },
      {
        slug: "dt-mesh",
        name: "DT Mesh/Rockfall Protection Net/Sausage Type Net",
        image: IMAGES.dtMesh,
        imageNote: "DT Mesh",
        desc:
          "Double-twisted mesh for robust containment and stabilization applications.",
        template: "geotech",
        spec: geotechSpec({
          material: "GI / Zn + Pvc double-twisted mesh",
          size: "Mesh opening & wire dia as specified",
          coating: "GI / PVC (as specified)",
          tensile: "As per wire grade",
          bundle: "Rolls / Sheet (as specified)",
          standards: "As per IS 16014:2018",
        }),
        features: ["Flexible structure", "High strength", "Project-specific fabrication"],
        applications: ["Slope stabilization", "Rockfall protection", "Erosion control"]
      },
      {
        slug: "gi-wire-netting-sheet",
        name: "GI Wire Netting Sheet",
        image: IMAGES.giWireNettingSheet,
        imageNote: "GI Wire Netting Sheet",
        desc:
          "Wire netting sheets for containment and flood control applications.",
        template: "geotech",
        spec: geotechSpec({
          material: "GI Wire Mesh using GI Wire and GI Pins",
          size: "Sheet size & mesh opening as specified",
          coating: "Galvanized Steel",
          tensile: "As per wire grade",
          bundle: "Stacks of Sheet",
        }),
        features: ["Uniform mesh", "GI coating", "Easy cutting & fixing"],
        applications: ["Flood control", "Riverbank Embankment", "Landslide control"]
      },
      {
        slug: "pvc-coated-gabion-box",
        name: "PVC Coated Gabion Box",
        image: IMAGES.pvcCoatedGabionBox,
        imageNote: "PVC Coated Gabion Box",
        desc:
          "PVC coated gabions for higher corrosion protection in aggressive environments.",
        template: "geotech",
        spec: geotechSpec({
          material: "Zn + Pvc double-twisted mesh",
          size: "As per box size & mesh opening",
          coating: "PVC/Polymer coated over GI",
          bundle: "Bundles of stacked Boxes",
          standards: "As per IS 16014:2018",
        }),
        features: ["PVC coating", "Long service life", "Custom sizes"],
        applications: ["Coastal & high moisture zones", "Drainage works", "Slope protection"]
      },
      {
        slug: "geobag",
        name: "Geo Bags",
        image: IMAGES.geobag,
        imageNote: "Geo Bags",
        desc:
          "Non-woven Geotextile fabric bags filled with sand.",
        template: "geotech",
        spec: geotechSpec({
          material: "Non-woven geotextile",
          size: "Bag size as specified",
          coating: "N/A",
          tensile: "As per fabric size",
          bundle: "Bundles of Bags",
        }),
        features: ["Filtration", "Separation", "Durable"],
        applications: ["Riverbank protection", "Drainage", "Slope protection"]
      },
      {
        slug: "hesco-basket",
        name: "Hesco Basket",
        image: IMAGES.hescoBasket,
        imageNote: "Hesco Basket",
        desc:
          "Hesco baskets (defensive barrier-style gabions) for rapid deployment earth-filled protection—used in temporary retaining, flood control and security perimeters.",
        template: "geotech",
        spec: geotechSpec({
          material: "GI welded mesh / gabion-style barrier with Geotextile",
          size: "Panel size & cell depth as specified",
          coating: "Galvanizeed Steel",
          tensile: "As per wire size",
          bundle: "Pallets / bundles (as specified)",
        }),

        features: [
          "Fast deployment and installation",
          "High-strength mesh containment",
          "Custom sizes as per site requirement",
          "Suitable for temporary or semi-permanent works"
        ],
        applications: [
          "Flood control and erosion protection",
          "Temporary retaining structures",
          "Security and perimeter barriers"
        ]
      },
      {
        slug: "geo-composite",
        name: "Geo Composite",
        image: IMAGES.geoComposite,
        imageNote: "Geo Composite",
        desc:
          "Composite geosynthetic solutions for drainage and reinforcement projects.",
        template: "geotech",
        spec: geotechSpec({
          material: "Composite geosynthetic (as specified)",
          size: "Roll width/length as specified",
          coating: "N/A",
          tensile: "As per product grade",
          bundle: "Rolls (as specified)",
        }),

        features: ["Integrated layers", "Improved drainage", "Consistent performance"],
        applications: ["Retaining structures", "Drainage systems", "Landfill works"]
      },
      {
        slug: "geo-grid",
        name: "Geo Grid",
        image: IMAGES.geoGrid,
        imageNote: "Geo Grid",
        desc:
          "Uni-axial and Bi-axial Geogrids for soil reinforcement and enhanced load distribution.",
        template: "geotech",
        spec: geotechSpec({
          material: "Polymer geogrid (as specified)",
          size: "Aperture & roll size as specified",
          coating: "N/A",
          tensile: "As per grade",
          bundle: "Rolls (as specified)",
        }),
        features: ["High tensile strength", "Stable reinforcement", "Multiple grades"],
        applications: ["Road strengthening", "Slope reinforcement", "Embankments"]
      }
    ]
  }
];

export const APPLICATIONS = [
  {
    title: "Road & Highway Projects",
    desc:
      "Supply for civil infrastructure—gabions, geosynthetics, tying wire and fencing solutions for site safety."
  },
  {
    title: "Railway Infrastructure",
    desc:
      "Products suitable for perimeter control, civil stabilization and general supply chain requirements."
  },
  {
    title: "Riverbank Protection",
    desc:
      "Gabion boxes and DT mesh solutions for erosion control, retaining structures and slope protection."
  },
  {
    title: "Border & Security Fencing",
    desc:
      "Razor wire, concertina coils and robust fencing for high-deterrence security needs."
  },
  {
    title: "Agriculture & Animal Fencing",
    desc:
      "Goatproof and farm fencing designed for long life in high rainfall conditions."
  },
  {
    title: "Industrial & Residential Projects",
    desc:
      "Chainlink fences, barbed wire and wire supply for factories, institutions, housing and industrial sites."
  }
];

export const FAQS = [
  {
    q: "Do you supply across Northeast India?",
    a: "Yes. We supply across the Northeastern part of India, and can support nearby states for bulk requirements. Share your location and quantity—our team will confirm logistics and lead time."
  },
  {
    q: "Can you manufacture custom sizes and specifications?",
    a: "Yes. We support custom diameters, mesh, aperture, coating type, roll sizes and packaging—subject to feasibility and order quantity."
  },
  {
    q: "Are your specifications IS/ASTM compliant?",
    a: "We manufacture with a quality-first process and can align supply to relevant IS/ASTM requirements as applicable. Confirm the exact standard in your RFQ for accurate compliance."
  },
  {
    q: "How fast can you deliver in Assam?",
    a: "Lead time depends on product type, customization and quantity. For most standard products, we aim for quick dispatch with reliable transport partners."
  }
];

export function normalizePhoneForWa(phone) {
  // Converts +91XXXXXXXXXX => 91XXXXXXXXXX
  return String(phone || "").replace(/[^0-9]/g, "");
}

